import InitPassword from './InitPassword';
export default InitPassword;
